import { render, staticRenderFns } from "./edit-advertise.vue?vue&type=template&id=54e3ee50&scoped=true&"
import script from "./edit-advertise.vue?vue&type=script&lang=js&"
export * from "./edit-advertise.vue?vue&type=script&lang=js&"
import style0 from "./edit-advertise.vue?vue&type=style&index=0&id=54e3ee50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3ee50",
  null
  
)

export default component.exports